<template>
  <v-container fluid class="mt-16 px-6">
    <div class="">
      <v-card flat>
        <v-card-title class="d-flex">
          <h2>Accounts</h2>
          <v-spacer></v-spacer>
          <add-account-modal />
        </v-card-title>
        <v-tabs v-model="activeTab">
          <v-tab>
            <v-icon left small>mdi-account</v-icon>
            <span class="text-none">Active Accounts</span>
          </v-tab>
          <v-tab>
            <v-icon left small>mdi-account-off</v-icon>
            <span class="text-none">Deleted Accounts</span>
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="activeTab">
          <v-tab-item>
            <v-card-text>
              <v-text-field
                label="Search for something"
                v-model="search"
                prepend-inner-icon="mdi-magnify"
                placeholder="John Doe"
              ></v-text-field>
              <p>List of registered accounts:</p>
              <v-data-table
                :search="search"
                class="mt-5"
                :items="users"
                :headers="headers"
                v-if="users"
                :loading="loading"
              >
                <template v-slot:item.hats="{ item }">
                  <v-chip
                    v-for="hat in item.hats || []"
                    :key="hat.id"
                    x-small
                    class="ma-1"
                    color="indigo"
                    text-color="white"
                    >{{ hat.name }}</v-chip
                  >
                  <span v-if="!(item.hats || []).length" class="grey--text"
                    >—</span
                  >
                </template>
                <template v-slot:item.actions="{ item }">
                  <div class="d-flex">
                    <edit-account-modal :item="item" />
                    <v-icon color="red" @click="del(item)">mdi-delete</v-icon>
                  </div>
                </template>
              </v-data-table>
            </v-card-text>
          </v-tab-item>
          <v-tab-item>
            <v-card-text>
              <v-text-field
                label="Search for something"
                v-model="deletedSearch"
                prepend-inner-icon="mdi-magnify"
                placeholder="John Doe"
              ></v-text-field>
              <p>List of deleted accounts:</p>
              <v-data-table
                :search="deletedSearch"
                class="mt-5"
                :items="deleted_users"
                :headers="deletedHeaders"
                v-if="deleted_users"
                :loading="loadingDeleted"
              >
                <template v-slot:item.actions="{ item }">
                  <v-btn icon color="success" @click="restore(item)">
                    <v-icon>mdi-restore</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-card-text>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import addAccountModal from "../components/Account/addAccountModal.vue";
import EditAccountModal from "../components/Account/editAccountModal.vue";
export default {
  components: { addAccountModal, EditAccountModal },
  data() {
    return {
      activeTab: 0,
      search: "",
      deletedSearch: "",
      loading: false,
      loadingDeleted: false,
      headers: [
        { text: "", value: "actions" },
        { text: "ID", value: "id" },
        { text: "username", value: "username" },
        { text: "Full Name", value: "full_name" },
        { text: "Address", value: "address" },
        { text: "Phone Number", value: "phone_number" },
        { text: "Created at", value: "created_at" },
        { text: "Hats", value: "hats", sortable: false },
        { text: "Branch", value: "branch.branch_name" },
        { text: "Is Active", value: "is_active" },
      ],
      deletedHeaders: [
        { text: "", value: "actions" },
        { text: "ID", value: "id" },
        { text: "username", value: "username" },
        { text: "Full Name", value: "full_name" },
        { text: "Phone Number", value: "phone_number" },
        { text: "Branch", value: "branch.branch_name" },
        { text: "Deleted at", value: "deleted_at" },
      ],
    };
  },
  computed: {
    ...mapGetters({
      users: "auth/users",
      deleted_users: "auth/deleted_users",
    }),
  },
  created() {
    this.get_users();
    this.fetch_deleted();
  },
  methods: {
    ...mapActions({
      get_users: "auth/get_users",
      delete_user: "auth/delete_user",
      get_deleted_users: "auth/get_deleted_users",
      restore_user: "auth/restore_user",
    }),
    async fetch_deleted() {
      this.loadingDeleted = true;
      try {
        await this.get_deleted_users();
      } finally {
        this.loadingDeleted = false;
      }
    },
    async del(item) {
      let x = await this.$confirm({
        title: "Delete Account",
        message:
          "Are you sure you want to delete this account? It will be moved to the Deleted Accounts tab and can be restored later.",
        color: "red",
        icon: "mdi-delete",
      });
      if (x) {
        this.delete_user(item).then(() => {
          this.$alert({
            title: "Success",
            message: "Successfully deleted an account",
            color: "success",
            icon: "mdi-check-circle",
          });
        });
      }
      this.loading = false;
    },
    async restore(item) {
      let x = await this.$confirm({
        title: "Restore Account",
        message: "Are you sure you want to restore this account?",
        color: "success",
        icon: "mdi-restore",
      });
      if (x) {
        this.restore_user(item).then(() => {
          this.$alert({
            title: "Success",
            message: "Successfully restored an account",
            color: "success",
            icon: "mdi-check-circle",
          });
        });
      }
    },
  },
};
</script>

<style></style>
